import { render, staticRenderFns } from "./ProductBundle.vue?vue&type=template&id=257d791a&scoped=true"
import script from "./ProductBundle.vue?vue&type=script&lang=js"
export * from "./ProductBundle.vue?vue&type=script&lang=js"
import style0 from "./ProductBundle.vue?vue&type=style&index=0&id=257d791a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "257d791a",
  null
  
)

export default component.exports